import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const RefereeManagement = () => {
    const [showGameModal, setShowGameModal] = useState(false);
    const [showAssignList, setShowAssignList] = useState(false);
    const [assignedReferee, setAssignedReferee] = useState("Unassigned");
    const [deleteGameModal, setDeleteGameModal] = useState(false);
    const [selectedGameId, setSelectedGameId] = useState("");

    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);
    const table4 = useRef(null);
    const table5 = useRef(null);
    const table6 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        [table1, table2, table3, table4, table5, table6].forEach((ref) => {
            if (ref.current) {
                $(ref.current).DataTable({
                    pageLength: 5,
                    lengthChange: false,
                    destroy: true,
                    dom:
                        "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                    buttons: ["copy", "excel", "pdf", "print"],
                });
            }
        });

        return () => {
            [table1, table2, table3, table4, table5, table6].forEach((ref) => {
                if (ref.current) $(ref.current).DataTable().destroy();
            });
        };
    }, []);

    const openGameDetail = () => {
        setShowGameModal(true);
    };

    const closeGameDetail = () => {
        setShowGameModal(false);
        setShowAssignList(false);
    };

    const toggleAssignList = () => {
        setShowAssignList(!showAssignList);
    };

    const assignRef = (refereeName) => {
        setAssignedReferee(refereeName);
        setShowAssignList(false);
        alert(`Referee ${refereeName} assigned successfully!`);
    };

    const openDeleteModal = (gameId) => {
        setSelectedGameId(gameId);
        setDeleteGameModal(true);
    };

    const closeDeleteModal = () => {
        setDeleteGameModal(false);
        setSelectedGameId("");
    };

    const confirmDelete = () => {
        alert(`Game ${selectedGameId} deleted successfully!`);
        closeDeleteModal();
    };

    return (
        <>
            <div className="page-wrapper referees-page">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referees</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            {/* filters row */}
                            <div className="row g-3 mb-4 game-management-filter">
                                <div className="col">
                                    <label>Season</label>
                                    <select className="form-select">
                                        <option>Spring 2026</option>
                                        <option>Winter 2026</option>
                                    </select>
                                </div>
                                <div className="col">
                                    <label>Age Group</label>
                                    <select className="form-select">
                                        <option>U-12</option>
                                        <option>U-10</option>
                                    </select>
                                </div>
                                <div className="col">
                                    <label>Club</label>
                                    <input className="form-control" placeholder="Club name" />
                                </div>
                                <div className="col">
                                    <label>Referee</label>
                                    <input className="form-control" placeholder="Referee" />
                                </div>
                                <div className="col d-flex align-items-end">
                                    <button className="btn btn-primary w-100">Apply</button>
                                </div>
                            </div>
                            {/* tabs: All, Upcoming, Live, Completed, Cancelled */}
                            <ul className="nav nav-tabs nav-primary mb-3">
                                <li className="nav-item"><a className="nav-link active" data-bs-toggle="tab" href="#all">All</a>
                                </li>
                                <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#scheduled">Scheduled</a></li>
                                <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#live">Live</a></li>
                                <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#completed">Completed</a></li>
                                <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#cancelled">Cancelled</a></li>
                                <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#pending">Pending</a>
                                </li>
                            </ul>
                            <div className="tab-content">
                                {/* ALL TAB (table with sample row) */}
                                <div className="tab-pane fade show active" id="all">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table1" ref={table1}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* SCHEDULED TAB */}
                                <div className="tab-pane fade" id="scheduled">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table2" ref={table2}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* LIVE TAB */}
                                <div className="tab-pane fade" id="live">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table3" ref={table3}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* COMPLETED TAB */}
                                <div className="tab-pane fade" id="completed">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table4" ref={table4}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* CANCELLED TAB */}
                                <div className="tab-pane fade" id="cancelled">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table5" ref={table5}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* PENDING TAB */}
                                <div className="tab-pane fade" id="pending">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" id="table6" ref={table6}>
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team </th>
                                                    <th>Age Group</th>
                                                    <th>Season</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Referee</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#GM-002</td>
                                                    <td>Stars U12 - North Stars SC</td>
                                                    <td>Bears U12 - Eagle Sports</td>
                                                    <td>U-12</td>
                                                    <td>Spring 2026</td>
                                                    <td>North Ground</td>
                                                    <td>Mar 2, 2:00 PM</td>
                                                    <td><span className="text-secondary">Unassigned</span></td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={toggleAssignList}>
                                                                    <i className="lni lni-plus" data-bs-toggle="tooltip" title="Assign Referee" />
                                                                </a>
                                                            </li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-002")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-005</td>
                                                    <td>Eagles U10 - Riverside</td>
                                                    <td>Tigers U10 - Metro</td>
                                                    <td>U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>City Park</td>
                                                    <td>Mar 5, 4:00 PM</td>
                                                    <td>John Miller</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={toggleAssignList}>
                                                                    <i className="lni lni-plus" data-bs-toggle="tooltip" title="Assign Referee" />
                                                                </a>
                                                            </li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-007</td>
                                                    <td>Lions U14 - Central Club</td>
                                                    <td>Falcons U14 - Westside</td>
                                                    <td>U-14</td>
                                                    <td>Spring 2026</td>
                                                    <td>Central Stadium</td>
                                                    <td>Mar 8, 3:30 PM</td>
                                                    <td>David Smith</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={toggleAssignList}>
                                                                    <i className="lni lni-plus" data-bs-toggle="tooltip" title="Assign Referee" />
                                                                </a>
                                                            </li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-010</td>
                                                    <td>Warriors U16 - Elite FC</td>
                                                    <td>Knights U16 - United Club</td>
                                                    <td>U-16</td>
                                                    <td>Spring 2026</td>
                                                    <td>Elite Arena</td>
                                                    <td>Mar 12, 5:00 PM</td>
                                                    <td>Michael Brown</td>
                                                    <td><span className="bg-upcoming">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={toggleAssignList}>
                                                                    <i className="lni lni-plus" data-bs-toggle="tooltip" title="Assign Referee" />
                                                                </a>
                                                            </li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>#GM-012</td>
                                                    <td>Sharks U18 - Ocean FC</td>
                                                    <td>Panthers U18 - Hilltop</td>
                                                    <td>U-18</td>
                                                    <td>Spring 2026</td>
                                                    <td>Ocean Ground</td>
                                                    <td>Mar 15, 6:00 PM</td>
                                                    <td>Chris Wilson</td>
                                                    <td><span className="bg-completed">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={toggleAssignList}>
                                                                    <i className="lni lni-plus" data-bs-toggle="tooltip" title="Assign Referee" />
                                                                </a>
                                                            </li>
                                                            <li><a href="#" onClick={() => openDeleteModal("#GM-005")}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Game Detail Modal - Only One */}
            {showGameModal && (
                <div className="modal show d-block game-modal" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">Game #GM-002</h5>
                                <button type="button" className="btn-close" onClick={closeGameDetail} />
                            </div>
                            <div className="modal-body p-4">
                                <div className="mb-4">
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Game ID</label>
                                            <h5>#GM-002</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Status</label>
                                            <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                                                ● Upcoming
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Home Team</label>
                                            <h5>Stars U12 / North Stars SC</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Away Team</label>
                                            <h5>Bears U12 / Eagle Sports</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Age Group</label>
                                            <h5>U-12</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Season</label>
                                            <h5>Spring 2026 (Jan 1 – Mar 22, 2026)</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Venue</label>
                                            <h5>North Ground</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Date &amp; Time</label>
                                            <h5>Mar 2, 2:00 PM</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Referee</label>
                                            <h5>{assignedReferee}</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Referee Payout</label>
                                            <h5>$150</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 mb-5">
                                    <h5>Referee Assignment</h5>
                                    <button onClick={toggleAssignList} className="btn btn-primary">Assign Referee</button>
                                    {showAssignList && (
                                        <div className="mt-3">
                                            <p className="mb-2">Eligible referees (Spring 2026, U-12, no conflict Mar 2 2:00PM)</p>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Age groups</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Mark Johnson</td>
                                                        <td>U-10, U-12</td>
                                                        <td>Available</td>
                                                        <td><button className="btn btn-sm btn-primary" onClick={() => assignRef('Mark Johnson')}>Assign</button></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Lisa Ray</td>
                                                        <td>U-12, U-15</td>
                                                        <td>Available</td>
                                                        <td><button className="btn btn-sm btn-primary" onClick={() => assignRef('Lisa Ray')}>Assign</button></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tom Harris</td>
                                                        <td>U-12</td>
                                                        <td>Available</td>
                                                        <td><button className="btn btn-sm btn-primary" onClick={() => assignRef('Tom Harris')}>Assign</button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <button className="btn btn-secondary mt-2" onClick={toggleAssignList}>Back</button>
                                        </div>
                                    )}
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <h6 className="fw-bold mb-0">TEAM ROSTERS</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="fw-bold mb-3">Stars U12</div>
                                        <div className="d-flex flex-column gap-2">
                                            <div>#7 Jake Smith</div>
                                            <div>#9 Tyler Brown</div>
                                            <div>#11 Ryan Davis</div>
                                            <div>#3 Oliver Lee</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="fw-bold mb-3">Bears U12</div>
                                        <div className="d-flex flex-column gap-2">
                                            <div>#4 Max Turner</div>
                                            <div>#8 Alex Kim</div>
                                            <div>#10 Sam Reed</div>
                                            <div>#6 Chris Perk</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {deleteGameModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" onClick={closeDeleteModal}></button>
                            </div>
                            <div className="modal-body">
                                <h5>Are you sure you want to delete this game?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Yes</button>
                                <button type="button" className="btn btn-secondary" onClick={closeDeleteModal}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RefereeManagement